import React, { useContext } from 'react';
import { useTheme } from '@mui/material/styles';
import { UiContext } from 'shared/lib/contexts/uiContext';
import cx from 'classnames';
import { defaultSpacingPresets } from 'shared/hooks/useGetSpacing';
import { IconProps } from 'shared/icons/iconProps';

export default function IconEmptyFolder({
  extColor,
  isAutoscallable = true,
  sizeKey = '92x92',
  onClick,
  style,
}: IconProps) {
  const {
    spacings: {
      icons: { [sizeKey]: size },
    },
  } = useContext(UiContext);

  const w = isAutoscallable ? size.w : defaultSpacingPresets.icons[sizeKey].w;
  const h = isAutoscallable ? size.h : defaultSpacingPresets.icons[sizeKey].h;

  return (
    <svg
      className={cx('icon', { 'icon-disabled': !onClick })}
      onClick={onClick}
      style={style}
      width={w}
      height={h}
      viewBox="0 0 92 92"
      fill="none"
    >
      <path
        d="M6.46875 27.6091C6.46875 24.6666 8.85412 22.2812 11.7966 22.2812H30.3004C31.773 22.2812 33.18 22.8908 34.1872 23.9652L38.5222 28.5891C39.5294 29.6635 40.9364 30.273 42.4091 30.273H72.401C75.3435 30.273 77.7289 32.6584 77.7289 35.6009V77.8908C77.7289 80.8333 75.3435 83.2187 72.401 83.2187H11.7966C8.85411 83.2187 6.46875 80.8333 6.46875 77.8908V27.6091Z"
        fill="#AE5AF5"
      />
      <path
        d="M14.5931 43.1987C15.0972 40.7155 17.2806 38.9308 19.8145 38.9308H80.2015C83.5699 38.9308 86.093 42.0176 85.4229 45.3187L78.5953 78.9508C78.0912 81.434 75.9079 83.2187 73.374 83.2187H12.9869C9.61847 83.2187 7.09539 80.1319 7.76553 76.8308L14.5931 43.1987Z"
        fill="#7C28E3"
      />
      <g filter="url(#filter0_dd_6143_43348)">
        <path
          d="M31.625 12.2187C31.625 10.6309 32.9122 9.34375 34.5 9.34375H63.25C64.8378 9.34375 66.125 10.6309 66.125 12.2188V28.0312C66.125 29.6191 64.8378 30.9062 63.25 30.9062H52.4472L48.8642 34.5L45.2812 30.9062H34.5C32.9122 30.9062 31.625 29.6191 31.625 28.0312V12.2187Z"
          fill="white"
        />
        <path
          d="M52.4472 30.4062H52.2396L52.0931 30.5532L48.8642 33.7918L45.6353 30.5532L45.4888 30.4062H45.2812H34.5C33.1883 30.4062 32.125 29.3429 32.125 28.0312V12.2187C32.125 10.9071 33.1883 9.84375 34.5 9.84375H63.25C64.5617 9.84375 65.625 10.9071 65.625 12.2188V28.0312C65.625 29.3429 64.5617 30.4062 63.25 30.4062H52.4472Z"
          stroke="#EEEEEE"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M44.773 16.023C45.0537 15.7423 45.5088 15.7423 45.7895 16.023L48.875 19.1085L51.9605 16.023C52.2412 15.7423 52.6963 15.7423 52.977 16.023C53.2577 16.3037 53.2577 16.7588 52.977 17.0395L49.8915 20.125L52.977 23.2105C53.2577 23.4912 53.2577 23.9463 52.977 24.227C52.6963 24.5077 52.2412 24.5077 51.9605 24.227L48.875 21.1415L45.7895 24.227C45.5088 24.5077 45.0537 24.5077 44.773 24.227C44.4923 23.9463 44.4923 23.4912 44.773 23.2105L47.8585 20.125L44.773 17.0395C44.4923 16.7588 44.4923 16.3037 44.773 16.023Z"
        fill="#8290A1"
      />
      <defs>
        <filter
          id="filter0_dd_6143_43348"
          x="23.625"
          y="5.34375"
          width="50.5"
          height="41.1562"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="4" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_6143_43348"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_6143_43348"
            result="effect2_dropShadow_6143_43348"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_6143_43348"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}
